import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=50706974"
import script from "./Contest.vue?vue&type=script&lang=ts"
export * from "./Contest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports